import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {RouterModule} from '@angular/router';
import {ToastNoAnimation, ToastrModule} from 'ngx-toastr';
import {ConfirmationPracticeRoundComponent} from './confirmation-practice-round/confirmation-practice-round.component';
import {ConfirmationRoundOneComponent} from './confirmation-round-one/confirmation-round-one.component';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule} from '@angular/forms';
import {PickListModule, TooltipModule} from 'primeng/primeng';
import {ToastModule} from 'primeng/toast';
import {NguiAutoCompleteModule} from '@ngui/auto-complete';
import {DataTablesModule} from 'angular-datatables';
import { ConfirmationRoundTwoComponent } from './confirmation-round-two/confirmation-round-two.component';
import { ConfirmationRoundThreeComponent } from './confirmation-round-three/confirmation-round-three.component';
import {ConfirmationRoundFourComponent} from './confirmation-round-four/confirmation-round-four.component';

@NgModule({
    declarations: [
    ConfirmationPracticeRoundComponent,
    ConfirmationRoundOneComponent,
    ConfirmationRoundTwoComponent,
    ConfirmationRoundThreeComponent,
    ConfirmationRoundFourComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        NgbModalModule,
        FormsModule,
        PickListModule,
        TooltipModule,
        ToastModule,
        RouterModule,
        NguiAutoCompleteModule,
        ToastrModule.forRoot({
            toastComponent: ToastNoAnimation,
        }),
        DataTablesModule
    ]
})
export class ConfirmationModule {
}
